import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {modalContentTypes} from './ModalContent';
import {GnObjectUtils} from 'geminis-ng-core';
import {NzModalRef, NzModalService} from 'ng-zorro-antd/modal';
import {GnMessageService} from '../message-service/message-service';

@Directive({
  selector: '[gn-modal-button]'
})
export class GnModalButtonDirective {

  @Input() title: string;
  @Input() content: string;
  @Input() params: any;
  @Input() okMethod: string;
  @Input() okDisabled: boolean;
  @Input() width: string;
  @Input() height: string;
  @Input() top: string;

  @Output() afterOpen = new EventEmitter<NzModalRef>();
  @Output() ok = new EventEmitter<boolean>();

  constructor(private modalService: NzModalService,
              private messageService: GnMessageService) {
  }

  @HostListener('click') onClick(): boolean {
    const contentConfig = modalContentTypes[this.content || 'json-form'];

    const modalRef = this.modalService.create({
      nzTitle: this.title,
      nzContent: contentConfig.type,
      nzComponentParams: this.params,
      nzWidth: this.width || contentConfig.width || '520px',
      nzBodyStyle: {overflow: 'auto', height: this.height || contentConfig.height || 'auto'},
      nzStyle: {top: this.top || contentConfig.top || '100px'},
      nzOkDisabled: this.okDisabled,
      nzOnOk: () => {
        const component = modalRef.getContentComponent();
        const result = GnObjectUtils.callFunc(component, this.okMethod || 'form.submit');
        if (!result || typeof result === 'boolean') {
          this.ok.emit(result);
          return result;
        } else {
          return result
            .then(value => {
              this.ok.emit(value);
              return value;
            })
            .catch(error => {
              this.messageService.error('处理错误');
              console.error(error);
              return false;
            });
        }
      }
    });
    modalRef.afterOpen.subscribe(() => {
      this.afterOpen.emit(modalRef);
    });

    // 防止在表单中提交
    return false;
  }
}
